<header class="topbar">

  <!-- LEFT -->
  <div class="left">
    <button (click)="toggleSidebar()" class="menu-btn">☰</button>
    <h2 class="app-title" routerLink="/app/home">
      <span class="logo">🧪</span>
      <span class="title">My Lab</span>
    </h2>
  </div>

  <!-- RIGHT -->
  <div class="right">

    <!-- 🔧 TOOLS DROPDOWN -->
    <div class="tools">
      <button (click)="toggleTools()" class="tools-btn">
        Tools ▾
      </button>

      <div *ngIf="toolsOpen" class="dropdown">
        <button
          (click)="openTool(item.componentKey)"
          *ngFor="let item of topMenuItems"
          class="dropdown-item">
          {{ item.label }}
        </button>
      </div>
    </div>

    <span *ngIf="auth.user$ | async as user" class="user">
      {{ user.username }}
    </span>
    <!-- LOGOUT -->
    <button (click)="logout()" *ngIf="auth.isLoggedIn()">
      Logout
    </button>

  </div>

</header>
